import React from "react";
import { Box, Grid } from "@mui/material";
import {
  footerBoxStyle,
  footerContainerStyle,
  gridContainerStyle,
  homePaceComponentStyle,
} from "../../utils/constants";
import useUpdateAuthToken from "../../hooks/useUpdateAuthToken";
import { useNavigate } from "react-router-dom";
import CartButton from "../../components/CartButton/CartButton";
import { useCartDrawer } from "../../components/CartComponent/CartDrawerProvider";
import BuyButton from "../../components/BuyButton/BuyButton";
import { FlexEndBox } from "../shared/styledComponents";

export const Footer: React.FC = () => {
  useUpdateAuthToken();

  const { openCart } = useCartDrawer();

  const navigate = useNavigate();
  const handlePurchase = () => {
    navigate("/hacer-pedido");
  };

  return (
    <Box sx={homePaceComponentStyle}>
      <Grid container direction="column" sx={gridContainerStyle}>
        <Grid item sx={footerContainerStyle}>
          <Box sx={footerBoxStyle}>
            <FlexEndBox sx={{ justifyItems: "center" }} width="100%">
              <CartButton onClick={() => openCart("item_maintenance")} minWidth="auto" />
              <Box pl={1}>
                <BuyButton handlePurchase={handlePurchase} />
              </Box>
            </FlexEndBox>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
